'use strict';

var workerPostValidation = require('app_custom_mufe/account/workerPostValidation');
var workerPostFieldSelector = '#siretNumber, #vatNumber, #address';

function updatePopinInputState($input) {
    var value = $.trim($input.val());
    var patternText = $.trim($input.attr('data-pattern') || '');
    var maxLength = Number($input.attr('maxlength'));
    var isPatternValid = true;
    var hasValue = value !== '';
    var $formGroup = $input.closest('.form-group');
    var $error = $formGroup.find('.invalid-feedback').first();
    var formatMessage = $.trim($input.attr('data-error1'));

    if (patternText && hasValue) {
        isPatternValid = new RegExp(patternText).test(value);
    }

    if (maxLength && hasValue && value.length > maxLength) {
        isPatternValid = false;
    }

    var hasError = hasValue ? !isPatternValid : $input.attr('aria-invalid') === 'true';

    $input.toggleClass('is-valid', hasValue && isPatternValid);
    $input.toggleClass('is-invalid', hasError);

    if (hasValue && isPatternValid) {
        $input.css('background-image', '');
    } else {
        // Hide default :valid icon until the field is valid after typing.
        $input.css('background-image', 'none');
    }

    $input.closest('.form-group').find('.clear-btn').first().toggle(hasValue && !isPatternValid);

    if (hasError) {
        if ($error.length) {
            if (hasValue) {
                $error.text(formatMessage);
            }
            $error.show();
        }
        $formGroup.addClass('is-invalid');
        $input.attr('aria-invalid', true);
    } else {
        if ($error.length) {
            $error.hide();
        }
        $formGroup.removeClass('is-invalid');
        $input.attr('aria-invalid', false);
    }
}

function bindPopinClearButtons($form) {
    $form.find('.clear-btn').off('click.professionalPopinClear').on('click.professionalPopinClear', function (event) {
        var $button = $(this);
        var $input = $button.closest('.form-group').find('input').first();

        event.preventDefault();

        if (!$input.length) {
            return;
        }

        $input.val('');
        $input.removeClass('is-valid is-invalid');
        $input.css('background-image', 'none');
        $button.hide();
        $input.trigger('input').focus();
    });
}

function bindPopinFieldState($form) {
    var $fields = $form.find(workerPostFieldSelector);

    $fields.each(function () {
        var $input = $(this);
        $input.removeClass('is-valid is-invalid');
        $input.css('background-image', 'none');
        $input.closest('.form-group').find('.clear-btn').first().hide();
    });

    $fields.off('input.professionalPopinState').on('input.professionalPopinState', function () {
        updatePopinInputState($(this));
    });

    $fields.off('blur.professionalPopinState').on('blur.professionalPopinState', function () {
        updatePopinInputState($(this));
    });
}

function bindProfessionalPopinValidation() {
    var $popin = $('.professional-worker-popin');
    var $overlay = $('.professional-worker-popin-overlay');
    let isVisible = $popin.hasClass('is-visible');
    var $form = $popin.find('#professionalWorkerForm');
    let $body = $('body');

    if (!$popin.length || !$form.length) {
        $popin = $('.professional-worker-account');
        $form = $popin.find('#professionalWorkerForm');
    }

    if (isVisible) {
        $overlay.appendTo($body);
        $popin.appendTo($body);
        $body.addClass('lock-body');
    } else {
        $body.removeClass('lock-body');
    }

    if (!$popin.length || !$form.length) {
        return;
    }

    workerPostValidation.bindFieldEvents($form);
    bindPopinFieldState($form);
    bindPopinClearButtons($form);

    $form.off('submit.workerPostValidation').on('submit.workerPostValidation', function (event) {
        event.preventDefault();
        if (!workerPostValidation.validateAll($form)) {
            $form.find(workerPostFieldSelector).each(function () {
                updatePopinInputState($(this));
            });
        } else {
            $.spinner().start();
            var form = $form.serialize();
            var $updateProfessionalURL = $form.attr('action');
            $.ajax({
                url: $updateProfessionalURL,
                method: 'POST',
                data: form,
                success: function success(data) {
                    if ($popin.hasClass('professional-worker-account')) {
                        location.href = data.redirectUrl.toString() + '?updated=true';
                    }
                    if (data.success) {
                        $popin.hide();
                        $overlay.remove();
                        if (isVisible) {
                            $popin.removeClass('is-visible');
                            $body.removeClass('lock-body');
                        }
                    }
                },
                error: function error() {
                    $.spinner().stop();
                },
                complete: function complete() {
                    $.spinner().stop();
                }
            });
        }
    });
}


module.exports = function () {
    bindProfessionalPopinValidation();
};
